import { BrowserIcon, Typography } from '@compass/components'

import { CellAction } from './CellAction'
import { columnHelper, isBrowser } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

export const browserDetailsColumn = columnHelper.display({
  id: 'browserDetails',
  header: 'Browser',
  cell: ({ row }) => {
    if (!isBrowser(row.original)) {
      return <NotApplicable />
    }

    const browserDetails = row.original.browser_details

    if (!browserDetails) {
      return <Unavailable />
    }

    const browserVersion =
      browserDetails.browser_major_version === 'Not Available'
        ? '(unknown version)'
        : browserDetails.browser_major_version
    return (
      <CellAction className='flex flex-row gap-2 items-center flex-nowrap'>
        <BrowserIcon type={browserDetails.browser_name} className='size-4 shrink-0' />
        <Typography className='text-nowrap'>{[browserDetails.browser_name, browserVersion].join(' ')}</Typography>
      </CellAction>
    )
  },
})
